import React from 'react';
import AddressSelector from './OrderSections/AddressSelector';
import './Address.css';
import ScreenTitle from '../components/ScreenTitle';

interface AddressPageProps {
  onSelect?: (addressId: number | null | undefined) => void;
  selectedId?: number | null | undefined;
}

const Address: React.FC<AddressPageProps> = ({ onSelect, selectedId }) => {
  const handleSelect = (addressId: number | null | undefined) => {
    if (onSelect) {
      onSelect(addressId);
    }
    // Optional: navigate back after selection
    // navigate(-1);
  };

  return (
    <div className="address-page-wrapper">
      <div className="address-page-container">
        <ScreenTitle getHeaderTitle={()=> "Select your address" } onBack = {()=>'/profile'}/>
        <AddressSelector 
          onSelect={handleSelect} 
          selectedId={selectedId} 
        />
      </div>
    </div>
  );
};

export default Address;